import { render } from "./alarm-tabs.vue?vue&type=template&id=04110ea6"
import script from "./alarm-tabs.vue?vue&type=script&lang=js"
export * from "./alarm-tabs.vue?vue&type=script&lang=js"

import "./alarm-tabs.vue?vue&type=style&index=0&id=04110ea6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__